export const ItemTypes = {
  CONSUMABLE: "consumable"
};
